import React from "react";

export interface Principle {
  num: string;
  kicker: string;
  title: React.ReactNode;
  body: React.ReactNode;
}

interface PrinciplesSectionProps {
  id?: string;
  eyebrow: React.ReactNode;
  heading: React.ReactNode;
  intro: React.ReactNode;
  principles: Principle[];
}

const PrinciplesSection: React.FC<PrinciplesSectionProps> = ({
  id,
  eyebrow,
  heading,
  intro,
  principles,
}) => {
  return (
    <section id={id} className="cs-section cs-principles">
      <div className="cs-principles-inner">
        <div className="cs-principles-head">
          <div>
            <div className="eyebrow">{eyebrow}</div>
            <h2>{heading}</h2>
          </div>
          <p>{intro}</p>
        </div>

        <div className="cs-principles-list">
          {principles.map((p) => (
            <article key={p.num} className="cs-principle">
              <div className="cs-principle-num">
                <span className="n">{p.num}</span>
                {p.kicker}
              </div>
              <h3>{p.title}</h3>
              <p>{p.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PrinciplesSection;
